tr<template>
    <div class='ItemHistory'>
        <table class="table">
            <thead>
                <tr>
                    <TableHead 
                        scope='col' 
                        v-for='(columnHeader, idx) in columnHeaders'
                        :key='idx'
                        :columnHeader='columnHeader'
                    >
                    </TableHead>
                </tr>
            </thead>
            <tbody>
                <tr v-for='productEntry in productHistory'>
                    <th scope="row"><input type="checkbox" id="checkone" name="checkone" value="one"></th>
                    <th scope="row">{{productEntry.date}}</th>
                    <td>{{productEntry.type}}</td>
                    <td>{{productEntry.from}}</td>
                    <td>{{productEntry.to}}</td>
                    <td>{{productEntry.quantity}}</td>
                    <td>{{productEntry.amount}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import TableHead from './TableHead'
    export default {
        name: 'ItemHistory',
        components: {
            TableHead
        },
        data(){
            return{
                columnHeaders:[
                    {'name':'checkAll'},
                    {'name':'Date'},
                    {'name':'Transaction Type'},
                    {'name':'From'},
                    {'name':'To'},
                    {'name':'Quantity'},
                    {'name':'Amount' }               
                ],
                productHistory: this.$store.getters['ItemCard/currentProductEditHistory'],
                
            }
        }
    }

</script>